import type { FC } from 'react';
import React, { useCallback, useState, useEffect } from 'react';

import UserflowTheme from '@lt/components/themes/userflow';
import { PriceChangePopup, ResponsiveModal } from '@lt/components';

const { PriceChangePopupDesktop, PriceChangePopupMobile } = PriceChangePopup;

interface Props {
  initialPrice: number;
  actualizePrice: number;
  hotelLink: string;
  onOrderConfirmed: () => void;
  isMobile: LT.isMobile;
  isShown?: boolean;
  onHitActualizePriceChange?: () => void;
}

const PriceChangePopupContainer: FC<Props> = (props) => {
  const {
    isMobile,
    hotelLink,
    initialPrice,
    actualizePrice,
    onOrderConfirmed,
    onHitActualizePriceChange,
    isShown = false,
  } = props;

  const [isOpen, setIsOpen] = useState(isShown);

  useEffect(() => {
    setIsOpen(isShown);
    if (onHitActualizePriceChange && isShown) {
      onHitActualizePriceChange();
    }
  }, [isShown]);

  const handleClick = useCallback(() => {
    setIsOpen(false);
    onOrderConfirmed();
  }, [setIsOpen, onOrderConfirmed]);

  const Component = isMobile ? PriceChangePopupMobile : PriceChangePopupDesktop;

  return (
    <UserflowTheme>
      <ResponsiveModal
        open={isOpen}
        showCloseIcon={false}
        onClose={() => undefined}
      >
        <Component
          oldPrice={initialPrice}
          newPrice={actualizePrice}
          onOrderConfirmed={handleClick}
          isMobile={isMobile}
          hotelLink={hotelLink}
        />
      </ResponsiveModal>
    </UserflowTheme>
  );
};

export default PriceChangePopupContainer;
